import Dialog from '@/components/shared/Dialogs/Dialog'
import ConfirmationDialog from '@/components/shared/Dialogs/ConfirmationDialog'

const defaultOptions = {
  canCancel: ['escape', 'outside'],
  trapFocus: true,
  ariaModal: true,
  ariaRole: 'alertdialog',
  width: 561,
}

export default {
  methods: {
    openErrorDialog({ title = null, content = null, onClose = null }) {
      const props = {
        variant: 'error',
        ...(title && { title }),
        ...(content && { content }),
      }
      this.$buefy.modal.open({
        ...defaultOptions,
        parent: this,
        component: Dialog,
        props,
        events: {
          ...(onClose && { close: onClose }),
        },
      })
    },

    openConfirmationDialog({
      title = null,
      content = null,
      confirmText = null,
      cancelText = null,
      onConfirm = null,
      onCancel = null,
    }) {
      const props = {
        ...(title && { title }),
        ...(content && { content }),
        ...(confirmText && { confirmText }),
        ...(cancelText && { cancelText }),
        ...(onConfirm && { onConfirm }),
        ...(onCancel && { onCancel }),
      }
      this.$buefy.modal.open({
        ...defaultOptions,
        parent: this,
        component: ConfirmationDialog,
        props,
      })
    },
  },
}
